import React from "react";
import "./PlanCard.css";
import { Button } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const PlanCard = ({
  plan,
  onSubscribe,
  onCancel,
  planData,
  isSelected,
  loading,
  cancelling,
}) => {
  const isCurrent = planData && planData.numOfPeople === plan.numOfPeople;
  const hasActivePlan = !!planData?._id;
  const expiryDate = planData?.expiry;
  const isCancelled = planData?.isCancelled;

  const handleClick = () => {
    if (!isCurrent && !loading) {
      onSubscribe(plan);
    }
  };

  /* plan.duration is in months. Anything other than 1 was still being
     labelled "/month", so a 6-month plan read as a monthly price. */
  const pricePeriod =
    plan.duration && plan.duration !== 1
      ? ` for ${plan.duration} months`
      : "/month";

  let buttonLabel = `Get ${plan.name}`;
  if (loading) {
    buttonLabel = "Processing...";
  } else if (isCurrent && !isCancelled) {
    buttonLabel = "Your current plan";
  } else if (isCurrent && isCancelled) {
    buttonLabel = "Plan cancelled";
  } else if (hasActivePlan) {
    buttonLabel = "Upgrade plan";
  }

  return (
    <div
      className={`plan-card${isCurrent ? " plan-card-current" : ""}${
        isSelected ? " plan-card-selected" : ""
      }`}
    >
      {/* Status runs as a banner across the top of the card, carrying the
          date with it, per the reference mock. It used to be a flag beside
          the name with the date further down next to the button - two
          fragments of one fact in two places. Still in flow, never
          absolutely positioned, so a long plan name cannot collide with
          it. */}
      {isCurrent && (
        <div
          className={`plan-banner${
            isCancelled ? " plan-banner-cancelled" : " plan-banner-active"
          }`}
        >
          <span className="plan-banner-status">
            {isCancelled ? "Cancelled" : "Current plan"}
          </span>
          {expiryDate && (
            <span className="plan-banner-date">
              {isCancelled ? "Access ends " : "Renews "}
              {dayjs(expiryDate).format("MMMM D, YYYY")}
            </span>
          )}
        </div>
      )}

      <div className="plan-body">
        <h3 className="plan-name">{plan.name}</h3>

        <p className="plan-price">
          <span className="plan-price-amount">${plan.price}</span>
          {/* The period was hardcoded to "/month". A 6-month plan priced at
              $299 was being advertised as $299 a month. */}
          <span className="plan-price-period">{pricePeriod}</span>
        </p>

        <ul className="plan-features">
          {(plan.description || []).map((item, i) => (
            <li key={i}>
              <CheckOutlined className="plan-feature-icon" aria-hidden="true" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Pushed to the bottom of the card so buttons line up across every
          card in the row regardless of how many features each one lists. */}
      <div className="plan-foot">
        <Button
          block
          type={isCurrent ? "default" : "primary"}
          className={isCurrent ? "plan-btn-current" : "plan-btn-primary"}
          disabled={isCurrent || loading}
          onClick={handleClick}
          loading={loading}
        >
          {buttonLabel}
        </Button>

        {isCurrent && !isCancelled && (
          <Button
            block
            type="text"
            danger
            className="plan-btn-cancel"
            onClick={onCancel}
            loading={cancelling}
          >
            {cancelling ? "Cancelling..." : "Cancel plan"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default PlanCard;
